import actionTypes from 'SRC/modules/redux/actionTypes'

export const setSpecifications = (specs) => ({
  type: actionTypes.SET_CATEGORY_SPECIFICATIONS,
  payload: specs
})
